// angular
import {Component, OnInit, inject} from "@angular/core";
import {Router, RouterOutlet} from "@angular/router";
import {NgxSpinnerModule} from "ngx-spinner";
import {NavigationEnd} from "@angular/router";
// services
import {MainConfigurationService} from "./shared/services/main-configuration.service";
import {UserService} from "./shared/services/user.service";
// types
import {IUserData} from "./shared/types/employee.type";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  standalone: true,
  imports: [NgxSpinnerModule, RouterOutlet],
})
export class AppComponent implements OnInit {
  private _mainConfigurationService = inject(MainConfigurationService);
  private _userService = inject(UserService);

  public user: IUserData;
  public isLoginPage: boolean;

  // dependencies
  private readonly _routerService = inject(Router);
  constructor() {
    this._routerService.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.isLoginPage =
          event.urlAfterRedirects === "/login" ||
          event.urlAfterRedirects === "/forgot-password";
      }
    });
  }

  async ngOnInit() {
    this._mainConfigurationService.init();
    this._userService.user$.subscribe((user) => (this.user = user));
  }
}
